import { FetchClient } from "../../utils/fetchClient";

export async function getFranchiseBrandOutboundChannelIds(franchiseId = 0, brandBrandId = 0, isEnabled = 1) {
    return await FetchClient(`/data/v3/outbound-channel-ids?franchise_id=${franchiseId}&brand_id=${brandBrandId}&is_enabled=${isEnabled}`).GET({})
}